import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import BundleDetails from './BundleDetails/BundleDetails';
import OrderList from './orderList';
import OrderDetails from './OrderDetails/orderDetails';
import LogDetails from './LogDetails';
import NoContent from './noContent';
import ActionHistoryList from './actionHistoryList';
import ActionHistoryDetails from './actionHistoryDetails';
import RecoverEmailAccounts from './recoverEmailAccounts';
import RecoveryWidget from './recoveryWidget';
import UserList from './userList';
import BulkMigration from './BulkMigration';
import MonitorTask from './MonitorTask';
import RedisCachedMailbox from './RedisCachedMailbox';
import { isEmptyObject } from './utils';
import { NavBarOptionValue } from '../model/navbarOptions';
import { fetchUserInfoAction } from '../actions/authActions';

const MainContent = () => {
  const scrollableDivRef = useRef(null);
  const dispatch = useDispatch();

  const {
    orders: {
      actionHistoryListSuccess,
      actionHistoryDetails,
      orderDetails,
      domainBundles,
      customerBundles,
      customers,
      recoverEmailAccountState,
      recoveryTaskInfo,
    },
    logs: {
      fetchLogsPayload: logDetails,
      fetchingLogs,
      page: pageToFetch,
      ipLogsData,
      protocolLogsData,
    },
    auth: { navbarOption, token: authToken },
    users: { userDetails },
    redisCachedMailbox,
  } = useSelector((state) => state);

  // Fetch user info on mount
  useEffect(() => {
    dispatch(fetchUserInfoAction(authToken));
  }, [dispatch, authToken]);

  // Define condition flags
  const isOrderDetailsPresent = Object.entries(orderDetails).length !== 0;
  const isActionHistoryListPresent = actionHistoryListSuccess;
  const isRecoverableAccountsPresent =
    recoverEmailAccountState.fetchRecoverableAccountsSuccess;
  const isActionHistoryDetailsPresent =
    Object.keys(actionHistoryDetails).length !== 0;
  const isBundleListPresent =
    domainBundles.length !== 0 || customerBundles.length !== 0 || customers.length !== 0;

  const isLogDetailsPresent =
    (logDetails && logDetails.length > 0) ||
    (ipLogsData && !isEmptyObject(ipLogsData)) ||
    Boolean(protocolLogsData);

  // Priority arrays for each navbar option
  const componentPriorityForOrders = [
    {
      renderCondition: isActionHistoryDetailsPresent,
      component: <ActionHistoryDetails />,
    },
    {
      renderCondition: isActionHistoryListPresent,
      component: <ActionHistoryList />,
    },
    {
      renderCondition: isRecoverableAccountsPresent,
      component: <RecoverEmailAccounts />,
    },
    { renderCondition: isOrderDetailsPresent, component: <OrderDetails /> },
    // { renderCondition: isOrderDetailsPresent, component: <BundleDetails /> },
    { renderCondition: isBundleListPresent, component: <OrderList /> },
  ];

  const componentPriorityForLogs = [
    {
      renderCondition:
        (fetchingLogs && pageToFetch === 1) || redisCachedMailbox.loading,
      component: <div className="log-loader"></div>,
    },
    {
      renderCondition: isLogDetailsPresent,
      component: <LogDetails scrollableDivRef={scrollableDivRef} />,
    },
    {
      renderCondition:
        redisCachedMailbox.data?.recipients || redisCachedMailbox.error,
      component: <RedisCachedMailbox />,
    },
  ];

  const componentPriorityForAdmin = [
    {
      renderCondition:
        userDetails.isUserListFetchInProgress &&
        userDetails.userList.length === 0,
      component: <div className="log-loader"></div>,
    },
    {
      renderCondition: userDetails.userList.length !== 0,
      component: <UserList />,
    },
  ];

  const componentPriorityForCreateTask = [
    { renderCondition: true, component: <BulkMigration /> },
  ];
  const componentPriorityForMonitorTask = [
    { renderCondition: true, component: <MonitorTask /> },
  ];

  // Select the appropriate component based on the current navbar option
  let componentPriorityToConsider;
  switch (navbarOption) {
    case NavBarOptionValue.ORDERS:
      componentPriorityToConsider = componentPriorityForOrders;
      break;
    case NavBarOptionValue.LOGS:
      componentPriorityToConsider = componentPriorityForLogs;
      break;
    case NavBarOptionValue.ADMIN:
      componentPriorityToConsider = componentPriorityForAdmin;
      break;
    case NavBarOptionValue.CREATE_TASK:
      componentPriorityToConsider = componentPriorityForCreateTask;
      break;
    case NavBarOptionValue.MONITOR_TASK:
      componentPriorityToConsider = componentPriorityForMonitorTask;
      break;
    default:
      break;
  }

  const componentInfo = componentPriorityToConsider?.find(
    (item) => item.renderCondition
  );
  const componentToDisplay = componentInfo ? (
    componentInfo.component
  ) : (
    <NoContent />
  );

  return (
    <div className="main-layout" ref={scrollableDivRef}>
      <div id="mainDiv" name="mainDiv" className="main-content">
        {componentToDisplay}
      </div>
      {recoveryTaskInfo.length !== 0 && <RecoveryWidget />}
    </div>
  );
};

export default MainContent;
